import { Component } from '@angular/core';
//import * as $ from 'jquery'; // colocar no angular.json -> scripts: "./node_modules/jquery/dist/jquery.min.js" (se jquery ainda estiver instalado)

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent {
	title = 'app';
}
